import akjet from "./brands/akjet/index.json";
import clockster from "./brands/clockster/index.json";

export type BrandConfig = {
  key: string;
  displayName: string;
  title: string;
  description: string;
  lang: string;
  appStoreId: string;
  playStoreId: string;
  colorPrimary: string;
  apiUrlStage: string;
  apiUrlProd: string;
  /** ID партнёра (whiteLabel) на сервере; у AKJET не задаётся. */
  whiteLabelIdStage?: number;
  whiteLabelIdProd?: number;
  sentryDsn: string;
  appName: string;
  appId: string;
  hostname: string;
  fontFamily?: string;
};

const brands: Record<string, BrandConfig> = {
  akjet,
  clockster,
};

const brandKey = process.env.REACT_APP_BRAND || "akjet";

const brand: BrandConfig = brands[brandKey];

if (!brand) {
  throw new Error(
    `[config] Unknown REACT_APP_BRAND="${brandKey}". ` +
      `Available: ${Object.keys(brands).join(", ")}`,
  );
}

export { brand };
